<script lang="ts">
    export let width = '22';
</script>

<svg
    {width}
    height="14"
    class="fill-none stroke-1 stroke-primary group-hover:sm:fill-base-100 transition-all"
    viewBox="0 0 26 14"
    xmlns="http://www.w3.org/2000/svg"
>
    <path d="M25.0523 7.0127L18.641 0.601436L1.36885 7.0127L18.641 13.424L25.0523 7.0127Z" />
</svg>
